/* global cgy_vars */
/* eslint no-undef: "error" */

export default {
  url: {
    categories: cgy_vars.links.categories,
    categoriesComplete: cgy_vars.links.categoriesComplete,
    category: cgy_vars.links.category,
    categoryInclude: cgy_vars.links.categoryInclude,
    category_infos: cgy_vars.links.category_infos,
    form: cgy_vars.links.form,
    list: cgy_vars.links.list,
    map: cgy_vars.links.map,
    mapUrl: cgy_vars.links.mapUrl,
    maps: cgy_vars.links.maps,
    pages: cgy_vars.links.pages,
    place: cgy_vars.links.place,
    places: cgy_vars.links.places,
    search: cgy_vars.links.search,
    nonce: ''
  }
}



// WEBPACK FOOTER //
// ./src/store/jsonUrl.js